<template>
  <z-form-group class="row">
    <div class="col-3 text-right">
      {{ $t('verification.settings.check.verification_type') }}
    </div>
    <div class="form-input col-9">
      <i-select :value="value_id" @on-change="set_value">
        <i-option v-for="item in items" :key="item.id" :value="item.id" :label="item.name" />
      </i-select>
    </div>
  </z-form-group>
</template>

<script>
  // import { TemplateService } from '@mailer/services/TemplateService';

  export default {
    data() {
      return {
        items: [],
        value_id: null
      };
    },
    created() {
      this.load();
    },
    methods: {
      load() {
        // TemplateService.getSelect().then(items => (this.items = items));
        this.items = [
          { body: 'sms', id: 0, name: 'SMS' },
          { body: 'call', id: 1, name: 'Call' }
        ];
      },
      set_value: function(current_id) {
        if (current_id) {
          const current_item = this.items.find(f => f.id === current_id);
          this.$emit('input', current_item);
        }

        this.$nextTick(() => (this.value_id = undefined));
      }
    }
  };
</script>
